/**
 * Tutorial guidato della pagina Utenti.
 *
 * Nessun preparativo: nuovo utente e modifica sono pagine (con un tutorial loro), e il
 * tutorial non preme niente che porti via da qui. I tre pallini della riga si
 * raccontano illuminando il pulsante, non il menu: un menu di Vuetify aperto dal
 * tutorial si richiude da solo al click su "Avanti".
 *
 * Il tutorial non tocca gli interruttori ne' le voci della riga: "Loggati come"
 * sostituirebbe la sessione in corso, Elimina cancella un accesso, e il badge fa
 * generare un'immagine al server. Quei passi illuminano e raccontano, senza premere.
 *
 * Attivo, Scaduto e "Loggati come" esistono solo per il superamministratore: per
 * tutti gli altri i passi degli interruttori si saltano da soli.
 */
const SCOPE = '[data-tour-scope="users"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createUsersTourSteps() {
	return [
		{
			body: 'Questi sono gli accessi al gestionale: una riga per persona, con la mail che usa per entrare. Non sono i clienti del sito - quelli stanno in Clienti - ma chi lavora qui dentro.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Gli utenti',
		},
		{
			body: "Il piu' in alto apre la pagina del nuovo utente: nome, mail e password iniziale. La mail e' anche il nome con cui entrera', quindi dev'essere una casella che la persona usa davvero.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un utente',
		},
		{
			body: "La ricerca filtra mentre scrivi e guarda profilo, nome e mail insieme: va bene sia un pezzo di nome sia un pezzo di mail. Se vedi utenti di piu' profili, accanto c'e' anche il filtro per profilo. Ricerca e filtro restano nell'indirizzo della pagina: un refresh, o il ritorno dalla scheda, li ritrova.",
			key: 'search',
			placement: 'bottom',
			target: at('search'),
			title: 'Cercare un utente',
		},
		{
			body: "La tabella mostra il profilo a cui l'utente appartiene, il nome, la mail e i due interruttori di stato. L'elenco arriva intero dal server: le pagine qui sotto servono solo a scorrerlo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "I tre pallini a inizio riga raccolgono tutte le azioni sull'utente: Modifica apre la sua pagina - nome, mail e password - Stampa badge genera il badge e lo manda in stampa, Elimina toglie l'accesso per sempre dopo una conferma. Il superamministratore trova anche Loggati come, che prende il posto della tua sessione finche' non esci, e Reimposta verifica in due passaggi per chi ha perso il telefono.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Le azioni sulla riga',
		},
		{
			body: "Attivo decide se la persona puo' entrare. Spegnendolo non si cancella niente - utente, permessi e storico restano - ma da quel momento l'accesso viene rifiutato. Prima di applicarlo viene chiesta conferma, con scritto di chi si tratta.",
			key: 'active',
			missing: 'skip',
			placement: 'left',
			target: at('active'),
			timeout: 250,
			title: 'Abilitare o bloccare l’accesso',
		},
		{
			body: "Scaduto non riguarda la singola persona ma il profilo a cui appartiene: e' la leva che segna un'attivita' come scaduta. Da usare con cognizione, perche' tocca tutti gli utenti di quel profilo, non solo questo. Anche qui viene chiesta conferma.",
			key: 'expired',
			missing: 'skip',
			placement: 'left',
			target: at('expired'),
			timeout: 250,
			title: "La modalita' Scaduto",
		},
	];
}
